import { render, staticRenderFns } from "./Bottombar.vue?vue&type=template&id=74540849&"
import script from "./Bottombar.vue?vue&type=script&lang=js&"
export * from "./Bottombar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports